import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getResourceChart';

export const getResourceChart = (params) => {
    return network.post(ENDPOINT, params).then((response) => response.data);
};
